// import React, { useState, useEffect } from "react";
// import CardContent from "@mui/material/CardContent";
// import axios from "axios";
// import Divider from "@mui/material/Divider";

// const PincodeStats = ({ setType, type }) => {
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(false);

//   async function getData() {
//     setLoading(true);
//     setError(false);
//     try {
//       const res = await axios.get(
//         `https://api.medstown.com/customer/api/pincodes/stats`
//       );
//       if (res.data?.data) {
//         setData(res.data.data);
//       } else {
//         setError(true);
//       }
//     } catch (error) {
//       setError(true);
//     } finally {
//       setLoading(false);
//     }
//   }

//   useEffect(() => {
//     getData();
//   }, []);

//   if (loading) {
//     return (
//       <div style={styles.loadingContainer}>
//         <p style={{ textAlign: "center" }}>Loading... </p>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div style={styles.errorContainer}>
//         <p style={{ textAlign: "center", color: "red" }}>
//           Failed to load data. Please try again later.
//         </p>
//         <button
//           onClick={() => {
//             setError(false);
//             getData();
//           }}
//         >
//           Retry
//         </button>
//       </div>
//     );
//   }

//   if (!data) {
//     return null;
//   }

//   return (
//     <div style={styles.divContainer}>
//       <div
//         style={styles.cardWrapper}
//         onClick={() => {
//           if (type !== "all") {
//             setType("all");
//           }
//         }}
//       >
//         <CardContent
//           style={{
//             ...styles.cardContent,
//             border: `2px solid ${type === "all" ? "#014D4D" : "transparent"}`,
//           }}
//         >
//           <p className="text-sm font-medium text-gray-600">Total PIN Codes</p>
//           <p className="font-large text-black-600 text-4xl">
//             {data?.totalPincodes}
//           </p>
//         </CardContent>
//       </div>

//       <Divider orientation="vertical" />

//       <div
//         style={styles.cardWrapper}
//         onClick={() => {
//           if (type !== "unique") {
//             setType("unique");
//           }
//         }}
//       >
//         <CardContent
//           style={{
//             ...styles.cardContent,
//             border: `2px solid ${
//               type === "unique" ? "#014D4D" : "transparent"
//             }`,
//           }}
//         >
//           <p className="text-sm font-medium text-gray-600">Unique PIN Codes</p>
//           <p className="font-large text-black-600 text-4xl">
//             {data?.uniqueActivePincodesCount +
//               data?.uniqueRequestedPincodesCount}
//           </p>
//         </CardContent>
//       </div>

//       <Divider orientation="vertical" />

//       <div
//         style={styles.cardWrapper}
//         onClick={() => {
//           if (type !== "active") {
//             setType("active");
//           }
//         }}
//       >
//         <CardContent
//           style={{
//             ...styles.cardContent,
//             border: `2px solid ${
//               type === "active" ? "#014D4D" : "transparent"
//             }`,
//           }}
//         >
//           <p className="text-sm font-medium text-gray-600">Active PIN Codes</p>
//           <p className="font-large text-black-600 text-4xl">
//             {data?.activePincodes}
//           </p>
//         </CardContent>
//       </div>

//       <Divider orientation="vertical" />

//       <div
//         style={styles.cardWrapper}
//         onClick={() => {
//           if (type !== "requested") {
//             setType("requested");
//           }
//         }}
//       >
//         <CardContent
//           style={{
//             ...styles.cardContent,
//             border: `2px solid ${
//               type === "requested" ? "#014D4D" : "transparent"
//             }`,
//           }}
//         >
//           <p className="text-sm font-medium text-gray-600">
//             Requested PIN Codes
//           </p>
//           <p className="font-large text-black-600 text-4xl">
//             {data?.requestedPincodes}
//           </p>
//         </CardContent>
//       </div>
//     </div>
//   );
// };

// const styles = {
//   divContainer: {
//     display: "flex",
//     justifyContent: "space-around",
//     alignItems: "center",
//     padding: "20px",
//     backgroundColor: "#f9f9f9",
//     borderRadius: "10px",
//     gap: 12,
//   },
//   cardWrapper: {
//     flex: 1,
//     textAlign: "center",
//     cursor: "pointer",
//     borderRadius: "10px",
//     backgroundColor: "#fff",
//   },
//   cardContent: {
//     padding: "20px",
//     textAlign: "center",
//     borderRadius: "10px",
//     backgroundColor: "#fff",
//     boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
//   },
//   loadingContainer: {
//     textAlign: "center",
//     padding: "20px",
//   },
//   errorContainer: {
//     textAlign: "center",
//     padding: "20px",
//     color: "red",
//   },
// };

// export default PincodeStats;


import React, { useState, useEffect } from "react";
import { 
  Card, 
  CardContent, 
  Typography, 
  Divider, 
  Stack, 
  Box, 
  useTheme, 
  alpha, 
  Skeleton, 
  Button, 
  useMediaQuery,
  Grid,
  Container
} from "@mui/material";

const PincodeStats = ({ setType, type }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
  const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const medstownColors = {
    primary: "#014D4D",
    secondary: "#02A0A0",
    accent: "#FFB800",
    success: "#4caf50",
    error: "#f44336",
    warning: "#ff9800",
  };

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  async function getData() {
    setLoading(true);
    setError(false);
    try {
      const res = await fetch("https://api.medstown.com/customer/api/pincodes/stats");
      const json = await res.json();
      if (json?.data) {
        setData(json.data);
      } else {
        setError(true);
      }
    } catch {
      setError(true);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getData();
  }, []);

  // Card config with mobile-optimized labels
  const cards = [
    {
      id: "all",
      label: isMobile ? "Total PINs" : "Total PIN Codes",
      shortLabel: "Total",
      value: data?.totalPincodes,
      color: medstownColors.primary,
    },
    {
      id: "unique",
      label: isMobile ? "Unique PINs" : "Unique PIN Codes",
      shortLabel: "Unique",
      value: data ? data.uniqueActivePincodesCount + data.uniqueRequestedPincodesCount : null,
      color: medstownColors.secondary,
    },
    {
      id: "active",
      label: isMobile ? "Active PINs" : "Active PIN Codes",
      shortLabel: "Active",
      value: data?.activePincodes,
      color: medstownColors.success,
    },
    {
      id: "requested",
      label: isMobile ? "Requested PINs" : "Requested PIN Codes",
      shortLabel: "Requested",
      value: data?.requestedPincodes,
      color: medstownColors.accent,
    },
  ];

  if (loading) {
    return (
      <Container maxWidth="xl" sx={{ px: isMobile ? 1 : 3 }}>
        <Grid container spacing={isMobile ? 1.5 : 2}>
          {[1, 2, 3, 4].map((index) => (
            <Grid item xs={6} sm={6} md={3} key={index}>
              <Skeleton
                variant="rectangular"
                height={isMobile ? 80 : 100}
                sx={{ borderRadius: 2 }}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth="xl" sx={{ px: isMobile ? 1 : 3 }}>
        <Box 
          textAlign="center" 
          sx={{ 
            py: isMobile ? 4 : 6,
            px: isMobile ? 2 : 4
          }}
        >
          <Typography 
            variant={isMobile ? "body2" : "body1"} 
            color={medstownColors.error} 
            gutterBottom
            sx={{ fontSize: isMobile ? '0.875rem' : '1rem' }}
          >
            Failed to load data. Please try again later.
          </Typography>
          <Button
            variant="contained"
            size={isMobile ? "small" : "medium"}
            onClick={() => {
              setError(false);
              getData();
            }}
            sx={{
              backgroundColor: medstownColors.primary,
              "&:hover": { backgroundColor: alpha(medstownColors.primary, 0.85) },
              fontSize: isMobile ? '0.75rem' : '0.875rem',
              px: isMobile ? 2 : 3,
              py: isMobile ? 0.75 : 1,
            }}
          >
            Retry
          </Button>
        </Box>
      </Container>
    );
  }

  if (!data) {
    return null;
  }

  return (
    <Container maxWidth="xl" sx={{ px: isMobile ? 1 : 3 }}>
      <Grid container spacing={isMobile ? 1.5 : 2}>
        {cards.map(({ id, label, shortLabel, value, color }) => (
          <Grid item xs={6} sm={6} md={3} key={id}>
            <Card
              onClick={() => {
                if (type !== id) setType(id);
              }}
              sx={{
                cursor: "pointer",
                height: isMobile ? 90 : 120,
                borderRadius: isMobile ? 2 : 3,
                boxShadow:
                  type === id
                    ? `0 ${isMobile ? 4 : 6}px ${isMobile ? 16 : 20}px ${alpha(color, 0.25)}`
                    : `0 2px 8px ${alpha(theme.palette.common.black, 0.15)}`,
                border: type === id ? `2px solid ${color}` : "1px solid transparent",
                transition: "all 0.3s ease",
                "&:hover": {
                  boxShadow: `0 ${isMobile ? 6 : 8}px ${isMobile ? 20 : 28}px ${alpha(color, 0.3)}`,
                  border: `2px solid ${alpha(color, 0.5)}`,
                  transform: isMobile ? 'translateY(-2px)' : 'translateY(-4px)',
                },
                // Gradient background for active cards
                background: type === id 
                  ? `linear-gradient(135deg, ${alpha(color, 0.1)} 0%, ${alpha(color, 0.05)} 100%)`
                  : 'white',
              }}
            >
              <CardContent 
                sx={{ 
                  textAlign: "center", 
                  py: isMobile ? 1.5 : 2.5,
                  px: isMobile ? 1 : 2,
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  '&:last-child': { pb: isMobile ? 1.5 : 2.5 }
                }}
              >
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ 
                    fontWeight: 600, 
                    fontSize: isMobile ? "0.65rem" : "0.75rem",
                    mb: isMobile ? 0.5 : 1,
                    lineHeight: 1.2,
                    display: isMobile ? 'block' : 'block'
                  }}
                >
                  {isSmallMobile ? shortLabel : label}
                </Typography>
                
                <Typography
                  variant={isMobile ? "h5" : "h4"}
                  component="div"
                  sx={{
                    fontWeight: "bold",
                    color: type === id ? color : theme.palette.text.primary,
                    letterSpacing: "-0.02em",
                    fontSize: { 
                      xs: "1.4rem", 
                      sm: "1.6rem", 
                      md: "1.8rem",
                      lg: "2rem" 
                    },
                    lineHeight: 1.1,
                  }}
                >
                  {value?.toLocaleString() ?? "--"}
                </Typography>

                {/* Optional: Add small indicator dot for active state on mobile */}
                {isMobile && type === id && (
                  <Box
                    sx={{
                      width: 6,
                      height: 6,
                      borderRadius: '50%',
                      backgroundColor: color,
                      mx: 'auto',
                      mt: 0.5,
                    }}
                  />
                )}
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Mobile-specific summary section */}
      {isMobile && data && (
        <Box
          sx={{
            mt: 2,
            p: 1.5,
            backgroundColor: alpha(medstownColors.primary, 0.05),
            borderRadius: 2,
            border: `1px solid ${alpha(medstownColors.primary, 0.1)}`,
          }}
        >
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{
              fontSize: '0.75rem',
              fontWeight: 600,
              display: 'block',
              textAlign: 'center',
            }}
          >
            Currently viewing: {cards.find(card => card.id === type)?.label || 'All PIN Codes'}
          </Typography>
        </Box>
      )}
    </Container>
  );
};

export default PincodeStats;

